/* eslint-disable no-unused-vars */
import Box from "@mui/material/Box";
import { Theme } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";

import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import Typography from "@mui/material/Typography";
import React from "react";
import { useTranslation } from "react-i18next";
import DeviceList from "./devices/DeviceList";
import RoleList from "./role/RoleList";
import UserList from "./user/UserList";

interface TabPanelProps {
  children?: React.ReactNode;
  index: any;
  value: any;
}

function TabPanel(props: TabPanelProps) {
  const { t } = useTranslation();
  const translate = t;
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: any) {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    display: "flex",
    height: 224,
  },
  tabs: {
    borderRight: `1px solid ${theme.palette.divider}`,
  },
}));

export default function VerticalTabs(props) {
  const { t } = useTranslation();
  const translate = t;
  const classes = useStyles();
  const [value, setValue] = React.useState(0);

  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setValue(newValue);
  };

  return (
    <div className={classes.root} style={{ height: "100%" }}>
      <Tabs
        orientation="vertical"
        value={value}
        onChange={handleChange}
        aria-label="Vertical tabs example"
        className={classes.tabs}
      >
        <Tab label={translate("Users")} {...a11yProps(0)} />
        <Tab label={translate("Roles")} {...a11yProps(1)} />
        <Tab label={translate("Devices")} {...a11yProps(1)} />
      </Tabs>
      <TabPanel value={value} index={0} style={{ width: "100%" }}>
        <div style={{ width: "100%" }}>
          <UserList
            showMessage={props.showMessage}
            setAlert={props.setAlert}
            context={props.context}
          ></UserList>
        </div>
      </TabPanel>
      <TabPanel value={value} index={1} style={{ width: "100%" }}>
        <div style={{ width: "100%" }}>
          <RoleList
            showMessage={props.showMessage}
            setAlert={props.setAlert}
            context={props.context}
          ></RoleList>
        </div>
      </TabPanel>

      <TabPanel value={value} index={2} style={{ width: "100%" }}>
        <div style={{ width: "100%" }}>
          <DeviceList
            showMessage={props.showMessage}
            setAlert={props.setAlert}
            context={props.context}
          ></DeviceList>
        </div>
      </TabPanel>
    </div>
  );
}
